"use strict";
export const migration11 = (state) => {
  if (!state?.user) {
    return state;
  }
  delete state.user.recentConnectionMeta;
  return { ...state, _persist: { ...state._persist, version: 11 } };
};
